export type LoadingSnapshot={
  phase:"checking"|"graphics"|"scene"|"ready"|"error";
  files:number;cachedBytes:number;receivedBytes:number;shaderDone:number;shaderTotal:number;
  cacheAvailable:boolean;error:string;
};
const initial:LoadingSnapshot={phase:"checking",files:0,cachedBytes:0,receivedBytes:0,shaderDone:0,shaderTotal:0,cacheAvailable:true,error:""};
let state={...initial};
const listeners=new Set<()=>void>();
const activityListeners=new Set<(resource:string)=>void>();
let notification:ReturnType<typeof setTimeout>|null=null;
function publish(){notification=null;for(const listener of listeners)listener();}
function update(values:Partial<LoadingSnapshot>){
  state={...state,...values};
  if(values.phase){if(notification)clearTimeout(notification);publish();}
  else if(!notification)notification=setTimeout(publish,70);
}
export const loadingState={
  subscribeActivity(listener:(resource:string)=>void){
    activityListeners.add(listener);return()=>{activityListeners.delete(listener);};
  },
  activity(resource:string){for(const listener of activityListeners)listener(resource);},
  subscribe(listener:()=>void){listeners.add(listener);return()=>{listeners.delete(listener);};},
  snapshot:()=>state,serverSnapshot:()=>initial,
  phase:(phase:LoadingSnapshot["phase"])=>update({phase}),
  file:(bytes:number,cached:boolean)=>update({files:state.files+1,
    cachedBytes:state.cachedBytes+(cached?bytes:0)}),
  received:(bytes:number)=>update({receivedBytes:state.receivedBytes+bytes}),
  shaders:(shaderDone:number,shaderTotal:number)=>update({shaderDone,shaderTotal}),
  cacheUnavailable:()=>update({cacheAvailable:false}),
  fail:(error:unknown)=>update({phase:"error",error:error instanceof Error?error.message:String(error)}),
};
